module.exports = __webpack_public_path__ + "static/media/107.5cf6454d.jpg";